'use strict';
import * as $j_com$002eraquo$002eairstream$002ecore$002e$002dTransaction from "./com.raquo.airstream.core.-Transaction.js";
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
import * as $j_scala$002eruntime$002e$002dAbstract$002dPartial$002dFunction from "./scala.runtime.-Abstract-Partial-Function.js";
import * as $j_scala$002escalajs$002eruntime$002e$002dAnon$002dFunction1$002e$0024$0024$002dLambda$0024412915ce24663401f4bc24349a746e1dbd693dc1 from "./scala.scalajs.runtime.-Anon-Function1.$$-Lambda$412915ce24663401f4bc24349a746e1dbd693dc1.js";
var $p;
/** @constructor */
function $c_Lcom_raquo_airstream_state_Var$$anon$1(outer) {
  this.F8 = null;
  if ((outer === null)) {
    throw $j_java$002elang$002e$002dObject.$ct_jl_NullPointerException__(new $j_java$002elang$002e$002dObject.$c_jl_NullPointerException());
  }
  this.F8 = outer;
}
export { $c_Lcom_raquo_airstream_state_Var$$anon$1 as $c_Lcom_raquo_airstream_state_Var$$anon$1 };
$p = $c_Lcom_raquo_airstream_state_Var$$anon$1.prototype = new $j_scala$002eruntime$002e$002dAbstract$002dPartial$002dFunction.$h_sr_AbstractPartialFunction();
$p.constructor = $c_Lcom_raquo_airstream_state_Var$$anon$1;
/** @constructor */
function $h_Lcom_raquo_airstream_state_Var$$anon$1() {
}
export { $h_Lcom_raquo_airstream_state_Var$$anon$1 as $h_Lcom_raquo_airstream_state_Var$$anon$1 };
$h_Lcom_raquo_airstream_state_Var$$anon$1.prototype = $p;
$p.Vm = (function(x) {
  return true;
});
$p.Ss = (function(x, default$1) {
  new $j_com$002eraquo$002eairstream$002ecore$002e$002dTransaction.$c_Lcom_raquo_airstream_core_Transaction(new $j_scala$002escalajs$002eruntime$002e$002dAnon$002dFunction1$002e$0024$0024$002dLambda$0024412915ce24663401f4bc24349a746e1dbd693dc1.$c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$1) => {
    this.F8.rl(x, _$1);
  })));
});
$p.de = (function(x) {
  return this.Vm(x);
});
$p.cr = (function(x, default$1) {
  return this.Ss(x, default$1);
});
var $d_Lcom_raquo_airstream_state_Var$$anon$1 = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lcom_raquo_airstream_state_Var$$anon$1, "com.raquo.airstream.state.Var$$anon$1", ({
  hm: 1,
  aO: 1,
  o: 1,
  t: 1,
  a: 1
}));
export { $d_Lcom_raquo_airstream_state_Var$$anon$1 as $d_Lcom_raquo_airstream_state_Var$$anon$1 };
